import RemoteEvaluateResult from "./RemoteEvaluateResult"
import Entity from "../../../model/Entity"
import { InAppMessageLayoutEvaluateResult } from "../../../evaluation/service/inappmessage/layout/InAppMessageLayoutEvaluateResult"
import { InAppMessageLayoutEvaluation } from "../../../evaluation/service/inappmessage/layout/InAppMessageLayoutEvaluation"
import { DecisionReason,
  AbstractInAppMessage,
  InAppMessageContext,
  InAppMessageContextMessage,
  InAppMessageEvaluateContext,
  InAppMessageEventTrigger,
  InAppMessagePeriod,
  InAppMessageTimetable
} from "../../../model/model"

/**
 * Server-resolved in-app message layout result. Shares the eligibility result's identity/metadata
 * and is itself the layout evaluate result: it carries the resolved message together with its own
 * reason and references.
 */
export default class InAppMessageLayoutRemoteEvaluateResult
  extends AbstractInAppMessage
  implements RemoteEvaluateResult, InAppMessageLayoutEvaluateResult {
  constructor(
    readonly id: number,
    readonly key: number,
    readonly order: number,
    readonly period: InAppMessagePeriod,
    readonly timetable: InAppMessageTimetable,
    readonly eventTrigger: InAppMessageEventTrigger,
    readonly evaluateContext: InAppMessageEvaluateContext,
    readonly messageContext: InAppMessageContext,
    readonly message: InAppMessageContextMessage,
    readonly reason: DecisionReason,
    readonly references: Entity[]
  ) {
    super()
  }

  toEvaluation(): InAppMessageLayoutEvaluation {
    return new InAppMessageLayoutEvaluation(this, this)
  }
}
